export default __webpack_public_path__ + "static/media/cta-bg.7e4bf3de.jpg";